export default "__VITE_ASSET__CtEw4MVa__"